import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { Configuration, RequestOptions, ServerResponse, Tarif, UserCredentials, UserRequest } from '../models';
import { AccountService } from './account.service';
import { AppConfig } from './app.config';
import { RestService } from './rest.service';
import { Payment } from '../models/payment-model';

@Injectable()
export class TarifService {

  constructor(
    private restService: RestService,
    private accountService: AccountService
  ) {
    this.Config = AppConfig.config;
    this.accountService.getLogOutSubscribtion().subscribe(result => {
      if (!result) {
          return;
      }
      this.tarifs = null;
      this.tarifsPromise = null;
  });
  }

  private Config: Configuration;
  private tarifs: Tarif[];
  private tarifsPromise: Promise<Tarif[]>;
  private requestOptions = new RequestOptions();

  private refresh(): Promise<Tarif[]> {
    return new Promise<Tarif[]>(resolve => {
      this.accountService.getCredentialsPromise().then(cred => {
        this.requestOptions = new RequestOptions();

        this.requestOptions.Id_session = cred.Id_Session;
        this.requestOptions.Id_app = this.Config.AppId;
        this.requestOptions.ManualJSON = 1;
        this.requestOptions.PageSize = 1000;
        this.requestOptions.Controller0 = 'dictionary';
        this.requestOptions.Section = 'Tarif';
        this.requestOptions.Method = 'Print';
        this.requestOptions.ApiVersion = 'v1';

        this.restService.get(
          this.requestOptions).then(tarifs => {
            if (tarifs) {
              const response: ServerResponse<Tarif> = tarifs;
              this.tarifs = response.Result.Resultset;
              resolve(this.tarifs);
            }
          });
      });
    });
  }

  public get(forceUpdate = false): Promise<Tarif[]> {
    if (this.tarifsPromise) {
      return this.tarifsPromise;
    }
    this.tarifsPromise = new Promise<Tarif[]>(resolve => {
      if (forceUpdate || !this.tarifs) {
        this.refresh().then(t => {
          resolve(t);
        });
        return;
      }
      resolve(this.tarifs);
    });
    return this.tarifsPromise;
  }

  public getOrderId(paymentType: number, amount: number): Promise<number> {
    return new Promise<number>(resolve => {
      return this.accountService.getCredentialsPromise().then(cred => {
        this.requestOptions = new RequestOptions();

        this.requestOptions.Id_session = cred.Id_Session;
        this.requestOptions.Id_app = this.Config.AppId;
        this.requestOptions.Controller0 = 'User';
        this.requestOptions.EntityId0 = cred.Id_User;
        this.requestOptions.Section = 'Payments';
        this.requestOptions.Method = 'insert';
        this.requestOptions.ApiVersion = 'v1';
        this.requestOptions.Id_PaymentType = paymentType;
        this.requestOptions.Amount = amount;

        this.restService.post(
          this.requestOptions).then(response => {
            resolve(response.Result.ReturnCode);
          });
      });
    });
  }

  public removePayment(orderId: number): Promise<null> {
    return new Promise<any>(resolve => {
      return this.accountService.getCredentialsPromise().then(cred => {
        this.requestOptions = new RequestOptions();

        this.requestOptions.Id_session = cred.Id_Session;
        this.requestOptions.Id_app = this.Config.AppId;
        this.requestOptions.Controller0 = 'User';
        this.requestOptions.Controller1 = 'Payments';
        this.requestOptions.EntityId1 = orderId;
        this.requestOptions.Method = 'delete';
        this.requestOptions.ApiVersion = 'v1';

        this.restService.post(
          this.requestOptions).then(() => {
            resolve();
          });
      });
    });
  }

  public updateTarif(tarifId: number): Promise<void> {

    return this.accountService.getCredentialsPromise().then(cred => {
      const request = new UserRequest();
      request.Id_session = cred.Id_Session;
      request.ApiVersion = 'v1';
      request.Id_app = this.Config.AppId;
      request.Controller0 = 'User';
      request.EntityId0 = cred.Id_User;
      request.Method = 'update';
      request.Id_Tarif = tarifId.toString();

      this.restService.post(request);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/tarif.service.ts